import { Button, UnorderedList, useDisclosure } from "@chakra-ui/react";
import BoxHeader from "components/elements/BoxHeader";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useEffect, useState } from "react";
import { ContactRow } from "components/elements/ContactRow";
import BorrowerContactsModal from "../BorrowerContactsModal";
import ContentBox from "components/elements/ContentBox";
import { isPermissionEnabled, permissionConstants, hasPermission } from "utils/permissionHelper";

const BorrowerContacts = ({
  borrower,
  loadBorrower,
}: {
  borrower: any;
  loadBorrower: () => void;
}) => {
  const { user } = useTenant();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    setContacts(borrower.contacts);
  }, [borrower]);

  const checkPermission = () => {
    if (hasPermission(user, permissionConstants.editBorrower)) {
      //permission check
      return false;
    }
    if (!isPermissionEnabled(user)) {
      // no permissions
      return false;
    }
    return true;
  };

  return (
    <ContentBox>
      <BoxHeader
        title="Borrower Contacts"
        rightAddon={
          user.type !== "borrower" && (
            <Button
              onClick={onOpen}
              color="primary"
              variant="ghost"
              px="0px"
              size="sm"
              isDisabled={checkPermission()}
            >
              Manage
            </Button>
          )
        }
      />
      <UnorderedList listStyleType="none" p="0px" m="0px">
        {contacts.map((contact: any) => (
          <ContactRow key={contact.id} contact={contact} />
        ))}
      </UnorderedList>
      <BorrowerContactsModal
        borrower={borrower}
        isOpen={isOpen}
        onClose={onClose}
        loadBorrower={loadBorrower}
      />
    </ContentBox>
  );
};

export default BorrowerContacts;
